export const DEFAULT_LOG_QUERY = {
  pageSize: 10,
  pageNumber: 1,
  eventType: 'AllUser',
  startTime: moment(new Date()).subtract(5, 'months').startOf('month').utc().unix(),
  endTime: moment().endOf('day').utc().unix(),
  keyword: '',
};
